import { createStyles, rem } from '@mantine/core'

export interface StylesParams {
  showFullSlide?: boolean
}

export default createStyles((theme, { showFullSlide }: StylesParams) => {
  return {
    carouselWrapper: {
      position: 'relative',
      '.mantine-Carousel-viewport': {
        position: 'relative',
        '&:before, &:after': {
          content: '""',
          position: 'absolute',
          top: 0,
          bottom: 0,
          zIndex: 1,
          width: rem(10),
          background: '#fff',
          boxShadow: '0px 0 10px 10px rgba(0, 0, 0, 0.05)',
          opacity: 0,
          transition: 'opacity 0.6s ease',
        },
        '&:before': {
          right: '100%',
          boxShadow: '0px 0 -10px 10px rgba(0, 0, 0, 0.05)',
        },
        '&:after': {
          left: '100%',
          boxShadow: '0px 0 10px 10px rgba(0, 0, 0, 0.05)',
        },
      },
      [`&.still-slide .mantine-Carousel-viewport`]: {
        '&:after': {
          opacity: 1,
        },
      },
      [`&.end-slide .mantine-Carousel-viewport`]: {
        '&:before': {
          opacity: 1,
        },
      },
      [theme.fn.smallerThan('sm')]: {
        ...(!showFullSlide && {
          marginRight: rem(-16),
        }),
      },
    },
  }
})
